import script from "./DetalharTurmaInstrutor.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalharTurmaInstrutor.vue?vue&type=script&setup=true&lang=js"

import "./DetalharTurmaInstrutor.vue?vue&type=style&index=0&id=32674cf6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32674cf6"]])

export default __exports__